
import { mapActions, mapGetters } from 'vuex'
import AuthenticationService from '@/services/AuthenticationService'
import BtnLoader from '@/utils/BtnLoader'
import ButtonsLogin from '@/components/includes/ButtonsLogin'
import messages from '@/config/messages'
import Alerts from '@/components/includes/Alerts'

export default {
  name: 'AuthLogin',
  components: { Alerts, ButtonsLogin },

  data () {
    return {
      email: '',
      password: '',
      send: false,
      alert: null,
    }
  },

  head () {
    const title = this.$t('pages.login.seo.metaTitle')
    const description = this.$t('pages.login.seo.metaDescription')
    return {
      title,
      meta: [
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'twitter:title', name: 'twitter:title', content: title },

        { hid: 'description', name: 'description', content: description },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'twitter:description', name: 'twitter:description', content: description },
      ]
    }
  },

  computed: {
    ...mapGetters({
      authErrorCode: 'auth/authenticationErrorCode',
      authError: 'auth/authenticationError',
      isAuthenticated: 'auth/isAuthenticated',
      user: 'user/getUser'
    }),
    displayAlert () {
      return !!this.alert
    }
  },

  async asyncData ({ query, store, redirect, localePath }) {
    const { success } = query
    if (!success && store.getters['auth/isAuthenticated']) {
      redirect(localePath('index'))
    }
  },

  watch: {
    async '$route.query' () {
      await this.readQuery()
    }
  },

  async created () {
    if (process.client && this.$store.getters['auth/isAuthenticated']) {
      const { provider, type, id } = this.$route.query
      if (provider && type && id) {
        await this.$store.dispatch('gtm/setUserProperties', { userId: id })
        this.$bugsnag.setUser(id)
        if (type === 'login') {
          await this.$store.dispatch('gtm/login', provider)
        } else if (type === 'sign_up') {
          await this.$store.dispatch('gtm/signUp', provider)
        }
      }
      await this.$router.push(this.localePath('index'))
    }
  },

  async beforeMount () {
    await this.readQuery()
  },

  methods: {
    ...mapActions({
      authLogin: 'auth/login'
    }),

    async readQuery() {
      const { from, error, email, token } = this.$route.query

      if (from) {
        this.alert = { type: 'warning', message: this.$t('pages.login.alert.needLogin') }
        return
      }

      if (error) {
        let msg = this.$t('common.alert.errorOccurred')
        switch (error) {
          case 'need_re_auth':
            msg = this.$t('pages.login.alert.invalidSession')
            break
          case 'already_an_account_with_email':
            msg = this.$t('pages.login.alert.alreadyAnAccountWithEmail')
            break
          case 'already_an_account_with_facebook':
            msg = this.$t('pages.login.alert.alreadyAnAccountWithFacebook')
            break
          case 'already_an_account_with_google':
            msg = this.$t('pages.login.alert.alreadyAnAccountWithGoogle')
            break
          case 'need_email_on_facebook':
            msg = this.$t('pages.login.alert.needEmailFacebook')
            break
          default:
            break
        }
        this.alert = { type: 'danger', message: msg }
      }
      if (email && !token) {
        this.email = email
        this.password = ''
      }

      if (email && token) {
        try {
          await AuthenticationService.validEmail({
            email,
            token
          })
          this.email = email
          this.alert = { type: 'warning', message: this.$t('pages.login.alert.validEmail', { email }) }
        } catch (err) {
          const { status } = err.response
          if (status === 498) {
            this.alert = { type: 'danger', message: this.$t('pages.login.alert.validEmailExpire') }
          } else if (status === 422) {
            this.alert = { type: 'danger', message: this.$t('pages.login.alert.validEmailInvalid') }
          } else {
            this.alert = { type: 'danger', message: this.$t('common.alert.errorOccurred') }
          }
        }
      }
    },

    async onSubmit () {
      const result = await this.$refs.formLogin.validate()
      if (result && !this.send) {
        this.send = true
        let btnLoader = new BtnLoader('loginSubmit')
        btnLoader.show()
        await this.login()
        btnLoader.hide()
        this.send = false
      }
    },

    async login () {
      const logged = await this.authLogin({
        email: this.email,
        password: this.password
      })

      const { from } = this.$route.query

      if (logged) {
        await this.$store.dispatch('user/fetchUser')
        this.$bugsnag.setUser(this.user.id, this.user.email, this.user.firstname + ' ' + this.user.lastname)
        this.$socket.connect()
        if (from) await this.$router.push(this.localePath(from.toString()))
        else await this.$router.push(this.localePath('account-info'))
      } else {
        // await this.$store.dispatch('alert/pushError', { msg: this.authError })
        this.alert = { type: 'danger', message: this.authError }
      }
    }
  }
}
